import React from 'react';
const RenderTextLtr = ({ text }) => {
  return <div dir="ltr">{text}</div>;
};
export default RenderTextLtr;
